<!-- eslint-disable eqeqeq -->
<template>
    <div class="liveanser">
        <div class="liveanserContent" v-if="isAnsering">
            <div class="liveanser-top">
                <span style="font-size: 16px;">{{ titTypeObj[question.type] }}</span>
                <div v-if="this.question.second != 0" style="display: flex;align-items: center;">
                    <img class="liveanser-top-timeicon" src="../assets/imgs/answer/answer_time_icon@2x.png" />
                    <span style="margin-left: 6px;color: #202020;font-size: 16px;">{{ timeoutStr }}</span>
                </div>
            </div>
            <div class="liveanser-middle">
                <div class="liveanserTitle" style="margin-bottom: 20px;">{{ question.title }}</div>
                    <template v-if="question.type != 4">
                        <div class="anserOptionList"
                        v-for="(item, index) in AnSerOption" @click="anserSelect(item, index)" :key="index">
                        <img style="width: 18px;height:18px;" v-show="item.select"
                            src="../assets/imgs/answer/anser_sel.png" />
                        <img style="width: 18px;height:18px;" v-show="!item.select"
                            src="../assets/imgs/answer/anwser_unsel.png" />
                        <span style="margin-left: 6px;font-size: 14px;color: #202020;line-height: 16px;word-break: break-all;">{{ item.key }}.{{ item.content
                        }}</span>
                    </div>
                    </template>
                    <textarea v-model="userTextAnswer" v-if="question.type == 4" class="anserTextA"
                        placeholder="请输入内容"></textarea>
                <div style="text-align: right;margin-top: 16px;">
                    <div class="liveanserbtn" @click="commitAnserTap">提交</div>
                </div>
            </div>
        </div>
        <div class="anserSccussContent" v-if="!isAnsering && isSatus != 3">
             <div class="anserSccussContentBg"></div>
            <img class="anserSccussImg" v-if="isSatus == 1" src="../assets/imgs/answer/answer_success_icon@2x.png" />
            <img class="anserSccussImg" v-if="isSatus == 2" src="../assets/imgs/answer/answer_error_icon@2x.png" />
            <div class="anserSccussText"> {{ isSatus == 1 ? "恭喜你，回答正确" : "很遗憾，回答错误" }}</div>
            <div class="anserSccussBtn" @click="ikonwnTap">{{ isSatus == 1 ? "我知道啦" : "再接再历" }}</div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import qs from 'qs'
import Tools from '../kits/Tools'
export default {
  props: ['ds_id', 'fans_id', 'channel_code','uid','LiveanserObj'],
  data () {
    return {
      AnSerOption: [],
      titTypeObj: {
        3: '判断题',
        1: '单选题',
        2: '多选题',
        4: '简答题'
      },
      question: {
        type:1,
        title: ''
      },
      sigleAnserAnser: '',
      mulitAnserAnser: '',
      rightErrorAnser: '',
      userTextAnswer: '',
      currsecond: 0,
      countdown:0,
      secodeTimer: null,
      isAnsering: true,
      isSatus: ''
    }
  },
  computed: {
    timeoutStr () {
      if (this.countdown > 0) {
        let min = parseInt(this.countdown / 60)
        let second = parseInt(this.countdown % 60)
        return `${min < 10 ? '0' + min : min}:${second < 10 ? '0' + second : second}`
      }
      return '00:00'
    }
  },
  watch: {
    LiveanserObj:{
      handler:function(newValue,oldValue){
        console.error("newValue",newValue)
        if (newValue && newValue.lqid) {
        this.getQuestion()
      }
      },
      immediate:true //第一次刷新页面时就会执行
    },
  },
  mounted () {

  },
  methods: {
    ikonwnTap () {
      this.$emit('hideliveAnser',false)
    },
    resetData () {
      this.sigleAnserAnser = ''
      this.mulitAnserAnser = ''
      this.rightErrorAnser = ''
      this.userTextAnswer = ''
      this.currsecond = 0
      this.countdown = 0
      this.isAnsering = true
      this.isSatus = ''
    },
    async getQuestion () {
      this.resetData()
      try {
        let params = 'lqid=' + this.LiveanserObj.lqid + '&qpid=' + this.LiveanserObj.qpid + '&org_id=' + this.uid
        let res = await this.axios.post(Tools.baseUrlSchool() + '/ds/user/question', params)
        if (res && res.data && res.data.code == 200) {
          console.error('res=====data', res.data.data)
          this.question = res.data.data
        //   this.question.type = 4
          if (this.question.type != 4) {
            if (this.question.type == 3) {
                this.AnSerOption = [{ key: 'A', content: '正确' }, { key: 'B', content: '错误' }]
            } else {
                this.AnSerOption = res.data.data.option
            }
          }
          this.currsecond = this.question.second
          this.countdown  = this.question.countdown
          this.$emit('hideliveAnser',true)
          this.daojishi()
        }
      } catch (error) {

      }
    },
    daojishi () {
      if (this.secodeTimer) {
        clearInterval(this.secodeTimer)
        this.secodeTimer = null
      }

      if (this.currsecond > 0 && this.countdown > 0) {
          this.secodeTimer = setInterval(() => {
            let i = parseInt(this.countdown)
            if (i == 0) {
              clearInterval(this.secodeTimer)
              this.secodeTimer = null
              this.$emit('hideliveAnser',false)
              return
            }
            this.countdown = this.countdown - 1
          }, 1000)
      }      
    },
    async commitAnserTap () {
      // 暂停倒计时
      console.error('res=====data==question_answer')
      if (this.secodeTimer) {
        clearInterval(this.secodeTimer)
        this.secodeTimer = null
      }
      let answerTmp = ''
      this.isSatus = 3
      if (this.question.type == 1) {
        if (!this.sigleAnserAnser) {
        this.$message({type: "error",message: "请选择答案"});
          return
        }
        answerTmp = this.sigleAnserAnser
      } else if (this.question.type == 2) {
        if (!this.mulitAnserAnser) {
            this.$message({type: "error",message: "请选择答案"});
          return
        }
        answerTmp = this.mulitAnserAnser
      } else if (this.question.type == 3) {
        if (!this.rightErrorAnser) {
          this.$message({type: "error",message: "请选择答案"});
          return
        }
        answerTmp = (this.rightErrorAnser == 'A') ? 1 : 2
      } else if (this.question.type == 4) {
        if (!this.userTextAnswer) {
          this.$message({type: "error",message: "请选择答案"});
          return
        }
        answerTmp = this.userTextAnswer
      }
      console.error('res=====data==question_answer', answerTmp)
      if (this.question.type != 4) {
        let question_answer = this.question.answer
        if (this.question.type != 3) { //单选题
           question_answer = JSON.parse(question_answer).sort().join(',')
        }
      
        if (answerTmp == question_answer) {
          this.isSatus = 1
        } else {
          this.isSatus = 2
        }
        console.error('res=====data==question_answer', question_answer)
      }
      console.error('res=====data', answerTmp)
      if (this.isSatus === 1) { // 回答正确
        this.isAnsering = false
      } else if (this.isSatus === 2) { // 回答错误
        this.isAnsering = false
      }else{
        this.$emit('hideliveAnser',false)
      }

      try {
          let params = {
              org_id:this.uid,
              dsid:this.ds_id,
              qpid:this.LiveanserObj.qpid,
              lqid:this.LiveanserObj.lqid,
              fans_id:this.fans_id,
              answer:answerTmp,
              status:this.isSatus,
              channel_code:this.channel_code
          }
          console.error("params====",params);
          let res = await this.axios.post(Tools.baseUrlSchool() + "/ds/user/answer", qs.stringify(params));
          if (res && res.data && res.data.code == 200) {
              console.error("res=====data", res.data.data)
          }else {

          }
      } catch (error) {
        console.error("error====",error);
      }
    },
    anserSelect (item, index) {
      if (this.question.type === 1) { // 单选题
        this.AnSerOption.forEach(element => {
          element.select = false
        })
        let currItem = Object.assign({}, item)
        currItem.select = true
        this.$set(this.AnSerOption, index, currItem)

        this.sigleAnserAnser = item.key
        console.log('sigleAnserOption', this.sigleAnserAnser)
      } else if (this.question.type === 2) { // 多选
        let currItem = Object.assign({}, item)
        currItem.select = !currItem.select
        this.$set(this.AnSerOption, index, currItem)
        let selectAndser = this.AnSerOption.filter(item => item.select)
        this.mulitAnserAnser = selectAndser.map(item => item.key).join(',')
        console.log('mulitAnserOption', this.mulitAnserAnser)
      } else if (this.question.type === 3) { // 判断题
        this.AnSerOption.forEach(element => {
          element.select = false
        })
        let currItem = Object.assign({}, item)
        currItem.select = true
        this.$set(this.AnSerOption, index, currItem)
        this.rightErrorAnser = item.key
      }
    }
  }
}
</script>
<style scoped>
.liveanser {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 2000;
}

.liveanser .liveanserbg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7)
}

.liveanser .liveanserContent {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 480px;
    transform: translate(-50%, -50%);
    background-color: white;
    border-radius: 12px;
    overflow: hidden;
}

.liveanser .liveanser-top {
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8eaec;
}

.liveanser .liveanser-top-timeicon {
    width: 22px;
    height: 22px;
}

.liveanser .liveanser-middle {
    padding: 20px 16px;
}

.liveanser .liveanserTitle{
  font-size: 14px;
  color: #202020;
  line-height: 22px;
  word-break: break-all;
}

.liveanser .liveanserbtn {
    width: 74px;
    height: 32px;
    display: inline-block;
    background: #10a675;
    border-radius: 16px;
    text-align: center;
    color: #ffffff;
    line-height: 32px;
    cursor: default;
}

.liveanser .anserTextA {
    width: 100%;
    height: 100px;
    background: #ffffff;
    border: 1px solid #dee2e9;
    border-radius: 4px;
    padding: 5px 8px;
    box-sizing: border-box;
    outline: none;
}

.liveanser .anserSccussContent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -88%);
    width: 280px;
    height: 280px;
    /* opacity: 0.4;
    background: radial-gradient(#ffd568, #ffdb85, rgba(255,223,141,0.37), rgba(255,219,127,0.09), rgba(249,235,196,0.00));
    filter: blur(1px); */
    /* background-image: url(../assets/imgs/answer/answer_yinying_bg@2x.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center; */
}

.liveanser .anserSccussContentBg {
    width: 280px;
    height: 280px;
    /* opacity: 0.4;
    background: radial-gradient(#ffd568, #ffdb85, rgba(255,223,141,0.37), rgba(255,219,127,0.09), rgba(249,235,196,0.00));
    filter: blur(1px); */
    background-image: url(../assets/imgs/answer/answer_yinying_bg@2x.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    animation: liveAnserRotate 3s linear infinite;
}

@keyframes liveAnserRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.liveanser .anserSccussImg {
    height: 92px;
    width: 92px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.liveanser .anserSccussText {
    color: #ffffff;
    font-size: 16px;
    line-height: 24px;
    position: absolute;
    top: 234px;
    left: 50%;
    width: 133px;
    transform: translateX(-50%);
}

.liveanser .anserSccussBtn {
    width: 120px;
    height: 40px;
    background: linear-gradient(137deg, #73aaff 5%, #0053ff 93%);
    border-radius: 20px;
    position: absolute;
    left: 50%;
    top: 272px;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    color: white;
    cursor: default;
    transform: translateX(-50%);
}

.liveanser .anserOptionList{
    margin-bottom: 19px;
    cursor: default;
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/liveanser.vue